import { Component, OnInit, ChangeDetectionStrategy } from '@angular/core';

@Component({
    selector: 'app-air-service',
    templateUrl: './air-service.component.html',
    styleUrls: ['./air-service.component.css'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class AirServiceComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }
 
}
